export default __webpack_public_path__ + "static/media/no-mistakes-illustration-main.53dd7b24.svg";